export default __webpack_public_path__ + "static/single-user-a8668ce9de4ea6ca7354bb708a4cb4a6.png";